import React, { useCallback, useState } from "react";
import getCroppedImg from "../../utils/cropImage";
import Cropper from "react-easy-crop";
import Spinner from "../spinners/Spinner";

export const CropImage = ({
  setCroppedImage,
  imageSrc,
  setImageSrc,
  setIsModalOpen,
  handleFileSave,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onCropComplete = useCallback(
    (croppedAreaPercentage, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
    },
    []
  );

  const saveCroppedImage = useCallback(async () => {
    setLoading(true);
    try {
      const { blob, url } = await getCroppedImg(imageSrc, croppedArea);
      const croppedFile = new File([blob], "cropped-image.jpg", {
        type: "image/jpeg",
      });
      setCroppedImage(url);
      await handleFileSave(croppedFile);
      setImageSrc(null);
      setIsModalOpen(false);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
      setError(
        e?.response ? e.response.data.message : "Error while uploading image."
      );
    }
  }, [imageSrc, croppedArea]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded shadow-lg w-[90%] max-w-[500px]">
        <h2 className="text-lg font-semibold mb-4">Upload Your Image</h2>
        <div className="relative w-full h-64">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="flex items-center justify-between mt-4">
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(e.target.value)}
            className="flex-1 mr-4"
          />
          <div className="grid grid-cols-2 gap-x-4">
            <button
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={saveCroppedImage}
              className="px-4 py-2 bg-primary text-white rounded hover:bg-teal-800 duration-300 transition flex items-center justify-center"
              type="button"
            >
              {loading ? <Spinner /> : "Save Image"}
            </button>
          </div>
        </div>
        {error && (
          <span className="text-sm block mt-3 text-[tomato]">{error}</span>
        )}
      </div>
    </div>
  );
};
